var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc41a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9113"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-crown"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crown",
    clipPath: "url(#clip-crown)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "royal-crown",
    transform: "translate(3.229 -59.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28944",
    "data-name": "Path 28944",
    d: "M138.641,809.368a1.318,1.318,0,0,0-1.318-1.318h-15.1a1.318,1.318,0,1,0,0,2.637h15.1A1.319,1.319,0,0,0,138.641,809.368Z",
    transform: "translate(-118 -726.36)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28945",
    "data-name": "Path 28945",
    d: "M1.57,72.336a.542.542,0,0,0,.062,0L3.722,79.9h16.1l2.09-7.565.062,0A1.568,1.568,0,1,0,20.4,70.768a1.526,1.526,0,0,0,.077.482L16.7,73.46l-4.063-6.736a1.568,1.568,0,1,0-1.731,0L6.844,73.46l-3.78-2.21a1.6,1.6,0,0,0,.077-.482,1.569,1.569,0,1,0-1.57,1.568Z",
    fill: "url(#linear-gradient)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.914ce52347647f3c32b4a166600c1791.svg";
export { ForwardRef as ReactComponent };